import { createSelector } from 'reselect';

export const getAddressSelector = createSelector(
  (form) => form.values.address,
  (address) => {
    if (address && address.country && address.addressLine1) {
      const countryCode = address.country.value;
      return {
        country: countryCode,
        state:
          address.administrativeArea && address.administrativeArea[countryCode]
            ? address.administrativeArea[countryCode].value ||
              address.administrativeArea[countryCode]
            : '',
        city: address.locality,
        line1: address.addressLine1,
        line2: address.addressLine2,
        postal_code: address.postalCode,
      };
    }

    return null;
  },
);

export const getBillingDetailsSelector = createSelector(
  getAddressSelector,
  (form) => form.values.first_name,
  (form) => form.values.email,
  (form) => form.values.phone,
  (address, name, email, phone) => {
    const billingDetails = { name: name || '' };
    if (address) {
      billingDetails.address = address;
    }
    if (email) {
      billingDetails.email = email;
    }

    if (phone) {
      billingDetails.phone = phone;
    }

    return billingDetails;
  },
);

export const getDonationFormFooterSettingsSelector = createSelector(
  (globalSettings) => globalSettings.generalSettings,
  (globalSettings) => globalSettings.footerSettings,
  (generalSettings, footerSettings) => {
    if (!generalSettings || !footerSettings) {
      return null;
    }
    return {
      columnOneHeader: generalSettings.checkoutFooterColumnOneHeader,
      columnOneContent: generalSettings.checkoutFooterColumnOneContent,
      columnTwoHeader: generalSettings.checkoutFooterColumnTwoHeader,
      columnTwoContent: generalSettings.checkoutFooterColumnTwoContent,
      text: generalSettings.checkoutFooterCopy,
      images: generalSettings.checkoutFooterLogos,
      googleTranslateEnabled: footerSettings.googleTranslateEnabled,
    };
  },
);
